<template>
  <mapbox-map class="mapboxgl-map" :map-classes="mapClasses" />
</template>

<script>
import MapFactory from '../utils/mapbox';
import MapboxMap from '../components/MapboxMap';
import {mapState} from 'vuex';

const DEFAULT_MAP_ZOOM = 16;

export default {
  components: {
    MapboxMap,
  },
  props: {
    mapClasses: {
      type: String,
      default: '',
    },
    locationCoords: {
      type: Object,
      default: () => null,
    },
    zoom: {
      type: Number,
      default: DEFAULT_MAP_ZOOM,
    },
    storeDetails: {
      type: Object,
      default: () => null,
    },
  },
  data() {
    return {
      map: undefined,
      marker: undefined,
      markerOptions: {draggable: false},
    };
  },
  computed: {
    ...mapState('backend', ['mapboxApiKey']),
  },
  async mounted() {
    this.map = await MapFactory({
      accessToken: this.mapboxApiKey,
      center: [this.locationCoords.lng, this.locationCoords.lat],
      zoom: this.zoom,
      cooperativeGestures: true,
    });
    this.map.includeZoomControl();
    // Added full screen control on map
    this.map.addFullscreenControl();

    this.marker = this.map.addMarker({
      position: [this.locationCoords.lng, this.locationCoords.lat],
      markerOptions: this.markerOptions,
    });

    const popupHtml = `<p class="font-semibold">${this.storeDetails.name}</p>
      <p>${this.storeDetails.address}</p>
      <p>${this.storeDetails.city}</p>
      <p>${this.storeDetails.zip}</p>
      <p>${this.storeDetails.country}</p>
      <p>${this.storeDetails.url}</p>`;

    this.map.addPopupToMarker({
      popupHtml: popupHtml,
      marker: this.marker,
      eventListenerObj: {},
    });
  },
  destroyed() {
    // Clean up all Mapbox things
    this.map.removeAllMapComponents();
  },
};
</script>
